import { useEffect, useState, useContext } from 'react'
import { ProfileContext, profileInit } from '../contexts'
import { useAction } from './useAction'

interface IUseProfileProps {
  profile: object
}
type UseProfileProps = IUseProfileProps

export const useProfile = (): UseProfileProps => {
  const { profileState, profileDispatch } = useContext(ProfileContext)
  const [profile, setProfile] = useState(profileState.profileData)

  useEffect(() => {
    setProfile(profileState.profileData)
  }, [profileState.profileData])

  // rootUrl?: string
  //
  // const getProfileUuid = (profile: { uuid: string }): string => {
  //   return profile.uuid
  // }
  //
  // if (rootUrl) {
  //   const { setAction } = useAction((!!profile && getProfileUuid(profile as { uuid: string })) || null,
  //     () => {
  //       void profileInit(profileDispatch, rootUrl, null).then()
  //     })
  //
  //   useEffect(() => {
  //     setAction((!!profile && getProfileUuid(profile as { uuid: string })) || null)
  //   }, [profile])
  // }

  return {
    profile
  }
}
